<template>
  <div class="flex-grid justify-center">
    <router-link 
      v-if="StepAsLink"
      :to="{ name: 'Woning', params: {'funnel': this.StepSummary}  }" 
      class="flex-grid"
    >
      <div class="col-small link">
        {{ StepSummary }}
      </div>
      <div class="col col-large content">
        <h4>{{ StepTitle }}</h4>
        <p>{{ StepDetail }}</p>
        <p 
          class="btn-orange-outlined"
          v-if="button"
          >
          {{ buttonTekst }}
        </p>
      </div>
    </router-link>
    <div 
      v-if="!StepAsLink"
      class="flex-grid"
    >
      <div class="col-small header">
        {{ StepSummary }}
      </div>
      <div class="col col-large content">
        <h4>{{ StepTitle }}</h4>
        <p>{{ StepDetail }}</p>
        <p
          v-if="button"
          class="btn-blue text-center"
        >
          {{ buttonTekst }} ...
      </p>
      </div>
    </div>
  </div>    
</template>

<script>
export default {
  name: "Step",
  props: {
    StepSummary: {
      type: String,
      required: false
    },
    StepTitle: {
      type: String,
      required: false
    },
    StepDetail: {
      type: String,
      required: false
    },
    StepAsLink: {
      type: Boolean,
      required: false
    },
    mainLink: {
      type: String,
      required: false
    },
    mainLinkText: {
      type: String,
      required: false
    },
    button: {
      type: Boolean,
      required: false,
      default: false
    },
    buttonTekst: {
      type: String,
      required: false,
    }
  }
};
</script>

<style scoped>
.link {
  font-size: 26px;
  font-weight: 300;
  color: black;
  text-transform: uppercase;
  margin-bottom: 32px;
  cursor:pointer;
}
.header {
  font-size: 26px;
  font-weight: 300;
  color: black;
  text-transform: uppercase;
  margin-bottom: 32px;
}
.content {
  color: black;
}
h4 {
  font-weight: bold;
}
.step__title {
  font-size: 24px;
  display: inline-block;
  margin-left: 24px;
}
.flex-grid {
  padding-bottom: 32px;
}
@media (min-width: 240px) and (max-width: 720px) {
  h2 {
    font-size: 36px;
    margin-bottom: 32px;
  }
  .flex-grid {
    margin: 0 2%;
    padding-bottom: 32px;
  }
  .step__title {
    margin-left: unset;
  }
}
</style>
  